import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState, useEffect } from "react";
import { htmlParser, EditorState, ContentState, convertFromHTML, convertToRaw, headerViewerLink, Grid, Paper, makeStyles, Typography, Divider, TemplateStatusChip } from "../../..";
import selects from "../../../assets/selects";
var useStyles = makeStyles(function (theme) {
  return {
    root: {
      padding: "4px 25px"
    },
    leftMain: {
      // [theme.breakpoints.up("md")]: {
      //   boxShadow: "15px 0 15px -5px #333"
      // },
      padding: "24px"
    },
    divider: {
      margin: "20px 0",
      height: "4px"
    },
    flex: {
      display: "flex",
      "justify-content": "space-between"
    }
  };
});

var BestPracticeInfo = function BestPracticeInfo(props) {
  // console.log("BestPracticeInfo props", props);
  var translation = props.translation,
      template = props.template,
      type = props.type;

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      links = _useState2[0],
      setLinks = _useState2[1];

  var editorState = template && template.details && EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(template.details).contentBlocks, convertFromHTML(template.details).entityMap));
  useEffect(function () {
    setLinks(headerViewerLink(convertToRaw(editorState.getCurrentContent()), true));
  }, [props]);

  var createContent = function createContent() {
    var dataFinal = template && template.details; // console.log("content initial", template.details);

    links.forEach(function (link) {
      dataFinal = dataFinal.replace(/<h(.?\d*?(?!.*?id=).*?)>/, // `<h${link.type} id="${link.link}">`
      "<h".concat(link.type, " id=\"").concat(link.link, "\" style=\"padding-top:80px\">"));
    });
    return htmlParser(dataFinal);
  };

  var classes = useStyles();
  return template && template.phases && template.phases.length > 3 ? /*#__PURE__*/React.createElement(Paper, {
    className: classes.leftMain
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, template ? template.name : ""), type && /*#__PURE__*/React.createElement(TemplateStatusChip, {
    label: translation ? translation.types[type] : selects.bestpractices_types[type]
  })), /*#__PURE__*/React.createElement(Divider, {
    className: classes.divider
  }), htmlParser(template ? template.details : "")) : /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 12,
    md: 12,
    lg: 12,
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 4,
    md: 4,
    lg: 4
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: "fixed",
      width: "22%"
    }
  }, links && links.map(function (link) {
    return link.html;
  }))), /*#__PURE__*/React.createElement(Grid, {
    item: true,
    xs: 8,
    md: 8,
    lg: 8
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.flex
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, template ? template.name : ""), type && /*#__PURE__*/React.createElement(TemplateStatusChip, {
    label: translation ? translation.types[type] : selects.bestpractices_types[type]
  })), /*#__PURE__*/React.createElement(Divider, {
    style: {
      marginTop: "20px",
      height: "5px",
      marginLeft: "30%",
      width: "40%",
      backgroundColor: "#3f9"
    }
  }), template && createContent()));
};

export { BestPracticeInfo };